import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Stack,
  Alert,
  CircularProgress,
} from "@mui/material";
import { patch } from "src/utils/networkUtils";

export default function ResetPasswordDialog({
  open,
  admin,
  onClose,
  onSuccess,
}) {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleClose = () => {
    setPassword("");
    setError(null);
    onClose();
  };

  const handleSubmit = () => {
    setLoading(true);
    setError(null);
    patch(`/admin/users/${admin.id}/reset-password`, { new_password: password })
      .then(() => {
        handleClose();
        onSuccess?.();
      })
      .catch((err) => {
        setError(err?.response?.data?.message ?? "Failed to reset password.");
      })
      .finally(() => setLoading(false));
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Reset Password</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          {error && <Alert severity="error">{error}</Alert>}
          <Typography variant="body2" color="text.secondary">
            Setting a new password for <strong>{admin?.email}</strong>.
          </Typography>
          <TextField
            label="New Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            helperText="Minimum 8 characters"
            fullWidth
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          variant="contained"
          color="warning"
          onClick={handleSubmit}
          disabled={loading || password.length < 8}
        >
          {loading ? <CircularProgress size={18} /> : "Reset Password"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
